<template>
    <div style="width:100%;height:100%">
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white;">
                <el-button type="primary" size="mini" @click="showitems">{{ $t('getapi[438]') }}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{ $t('getapi[4411]') }}</el-button>
                
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 10px"
                    >
                    <el-button slot="trigger" size="mini" type="primary">{{ $t('getapi[4410]') }}</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{ $t('getapi[506]') }}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{ $t('getapi[507]') }}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <!-- <div slot="header" class="clearfix"><span>计划相关设置</span></div> -->
            <vxe-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    resizable
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    tab-click="selectInfo(0)"
                    @checkbox-change="handleSelectionChange"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <vxe-table-column type="checkbox" width="80" align="center"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="exclusively_id" title="ID" v-if="false"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="sales_part" :title="$t('getapi[2652]')" width="80"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width="80"></vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'cus_chartnum' ? 'check' : ''" show-overflow-tooltip
                                 field="cus_chartnum" :title="$t('getapi[8595]')"  width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.cus_chartnum"
                                  v-if="editPlan == 'cus_chartnum'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'cus_chartnum'">{{ scope.row.cus_chartnum }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'tag_packag' ? 'check' : ''" show-overflow-tooltip
                                 field="tag_packag" :title="$t('getapi[6383]')"  width="100">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.tag_packag"
                                  v-if="editPlan == 'tag_packag'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'tag_packag'">{{ scope.row.tag_packag }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'cuspart_id' ? 'check' : ''" show-overflow-tooltip
                                  field="cuspart_id" :title="$t('getapi[2390]')"  width="100">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.cuspart_id"
                                  v-if="editPlan == 'cuspart_id'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'cuspart_id'">{{ scope.row.cuspart_id }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'cust_version' ? 'check' : ''" show-overflow-tooltip
                                  field="cust_version" :title="$t('getapi[8201]')"  width="100">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.cust_version"
                                  v-if="editPlan == 'cust_version'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'cust_version'">{{ scope.row.cust_version }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'isfreeze' ? 'check' : ''"
                                 field="isfreeze" :title="$t('getapi[555]')" width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.isfreeze"
                                   v-if="editPlan == 'isfreeze'">
                            <el-option v-for="item in isfreezeflag" 
                                :key="item.value" :title="item.title" :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'isfreeze'">{{ scope.row.isfreeze }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'custdraw_version' ? 'check' : ''" show-overflow-tooltip
                                  field="custdraw_version" :title="$t('getapi[12858]')"  width="100">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.custdraw_version"
                                  v-if="editPlan == 'custdraw_version'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'custdraw_version'">{{ scope.row.custdraw_version }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'customsname' ? 'check' : ''" show-overflow-tooltip
                                  field="customsname" :title="$t('getapi[12969]')"  width="100">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.customsname"
                                  v-if="editPlan == 'customsname'" type="text" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'customsname'">{{ scope.row.customsname }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'base_price' ? 'check' : ''" show-overflow-tooltip
                                  field="base_price" :title="$t('getapi[13011]')"  width="100" v-if="a125 == 1">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.base_price"
                                  v-if="editPlan == 'base_price'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'base_price'">{{ scope.row.base_price }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'base_net_price' ? 'check' : ''" show-overflow-tooltip
                                  field="base_net_price" :title="$t('getapi[13012]')"  width="100" v-if="a125 == 1">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.base_net_price"
                                  v-if="editPlan == 'base_net_price'" type="number"  autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'base_net_price'">{{ scope.row.base_net_price }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'tag_single' ? 'check' : ''" show-overflow-tooltip
                                  field="tag_single" :title="$t('getapi[6382]')"  width="100">
                    <template scope="scope" align="right">
                        <el-input class-name="check" size="small" v-model="scope.row.tag_single"
                                  v-if="editPlan == 'tag_single'" type="text"  autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'tag_single'">{{ scope.row.tag_single }}</span>
                    </template>
                </vxe-table-column>
                
            </vxe-table>
        </el-card>
        <!--<pickpart :isVisible="itevisible" @getitembom="getitembom" ref="input"></pickpart>-->
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Sal/Part/SalGetPart'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'salepartsetting',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [
                    {
                        value: '0',
                        label: this.$t('getapi[852]')//'未选择'
                    },
                    {
                        value: 'cus_chartnum',
                        label: this.$t('getapi[8595]')//'客户图号'
                    },
                    {
                        value: 'tag_packag',
                        label: this.$t('getapi[6383]')//'产品包装箱标签'
                    },
                    {
                        value: 'cuspart_id',
                        label: this.$t('getapi[2390]')//'客户零件号'
                    },
                    {
                        value: 'cust_version',
                        label: this.$t('getapi[8201]')//'客户零件版本'
                    },
                    {
                        value: 'isfreeze',
                        label: this.$t('getapi[555]')//'是否冻结'
                    },
                    {
                        value: 'custdraw_version',
                        label: this.$t('getapi[12858]')//'客户图纸版本'
                    },
                    {
                        value: 'customsname',
                        label: this.$t('getapi[12969]')//'报关品名'
                    },
                    {
                        value: 'base_price',
                        label: this.$t('getapi[13011]')//'基准含税价'
                    },
                    {
                        value: 'base_net_price',
                        label: this.$t('getapi[13012]')//'基准不含税价'
                    },{
                        value: 'tag_single',
                        label: this.$t('getapi[6382]')//'产品单件标签'
                    },

                    
                ],
                scrollTop:0,
                isfreezeflag: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
                a125:0,// 判断是否显示基准含税价和基准不含税价
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Sal/Part/SalImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.$http.urlpost('Basic/GetCurARate', {}, function (res) {
                if (res.Success == 1) {
                    that.a125 = res.DataContent[0].a125

                }
            });
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12632]"),this.$t("getapi[14]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            getitembom(data) {
                let that = this;
                console.log(data)
                if(data.length>0){
                    let str = ""
                    let ids = ''
                    if(data.length > 0){
                        for (let i = 0; i < data.length; i++) {
                            str = str + data[i].exclusively_id + ","
                        }
                        ids = str.substr(0, str.length - 1)
                    }
                    let parm = {
                        PageIndex: 0,
                        PageSize: 0,
                        Param: {
                            Id: 0,
                            Code: ids,
                            Name: '',
                            Where: ''
                        },
                        id: '',
                        name: ''
                    };
                    that.$http.urlpost('/Sal/Part/GetPartSalInfo', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent
                            data = data.filter(item => {
                                return that.dataSet.every(item2 => {
                                    return item.Exclusively_id != item2.Exclusively_id;
                                });
                            });
                            for (let i = 0; i < data.length; i++) {
                                that.dataSet = [...that.dataSet, {
                                    exclusively_id: data[i].exclusively_id,
                                    sales_part: data[i].sales_part,
                                    part_version: data[i].part_version,
                                    part_name: data[i].part_name,
                                    cust_version: data[i].cust_version,
                                    item_code: data[i].item_code,
                                    item_name: data[i].item_name,
                                    model:data[i].model,
                                    spec:data[i].spec,
                                    sales_unit_name: data[i].sales_unit_name,
                                    inv_unit_name: data[i].inv_unit_name,
                                    change_rate: data[i].change_rate,
                                    price: data[i].price,
                                    net_price: data[i].net_price,
                                    currency_unit: data[i].currency_unit,
                                    package_name: data[i].package_name,
                                    sales_type_name: data[i].sales_type_name,
                                    cuspart_id: data[i].cuspart_id,
                                    cuspart_name: data[i].cuspart_name,
                                    remark: data[i].remark,
                                    create_person: data[i].create_person,
                                    create_time: data[i].create_time,
                                    update_person: data[i].update_person,
                                    update_time: data[i].update_time,
                                    audit_status: data[i].audit_status,
                                    batch_price_flag: data[i].batch_price_flag,
                                    package_size: data[i].package_size,
                                    tag_single: data[i].tag_single,
                                    tag_packag: data[i].tag_packag,
                                    cus_chartnum: data[i].cus_chartnum,
                                    processing: data[i].processing,
                                    datastatus: data[i].datastatus,
                                    isfreeze: data[i].isfreeze,
                                    custdraw_version:data[i].custdraw_version,
                                    customsname:data[i].customsname,
                                    base_price:data[i].base_price,
                                    base_net_price:data[i].base_net_price,
                                }];
                            }
                        }
                    });
                }
            },
            handleSelectionChange({records}) {
                let that = this;
                for (let i = 0; i < records.length; i++) {
                    that.dataChecked.push(records[i].Exclusively_id);
                }
            },
            remove() {
                // let that = this;
                // let arr = that.dataSet.filter(item => {
                //     return that.dataChecked.every(item2 => {
                //         return item.Exclusively_id != item2;
                //     });
                // });

                let that = this;
                let selectRecords = this.$refs.singleTable.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.singleTable.getRowIndex(selectRecords[i]);
                    that.dataSet.splice(line, 1);
                }

                // that.dataSet = arr;
            },
            handleChange(file, fileList) {
                let that = this;
                /*if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.dataSet = file.response.DataContent;
                    }
                }*/
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                that.fileList=[];
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    
                    let data = res.DataContent
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            exclusively_id: data[i].exclusively_id,
                            sales_part: data[i].sales_part,
                            part_version: data[i].part_version,
                            part_name: data[i].part_name,
                            cust_version: data[i].cust_version,
                            item_code: data[i].item_code,
                            item_name: data[i].item_name,
                            model:data[i].model,
                            spec:data[i].spec,
                            sales_unit_name: data[i].sales_unit_name,
                            inv_unit_name: data[i].inv_unit_name,
                            change_rate: data[i].change_rate,
                            price: data[i].price,
                            net_price: data[i].net_price,
                            currency_unit: data[i].currency_unit,
                            package_name: data[i].package_name,
                            sales_type_name: data[i].sales_type_name,
                            cuspart_id: data[i].cuspart_id,
                            cuspart_name: data[i].cuspart_name,
                            remark: data[i].remark,
                            create_person: data[i].create_person,
                            create_time: data[i].create_time,
                            update_person: data[i].update_person,
                            update_time: data[i].update_time,
                            audit_status: data[i].audit_status,
                            batch_price_flag: data[i].batch_price_flag,
                            package_size: data[i].package_size,
                            tag_single: data[i].tag_single,
                            tag_packag: data[i].tag_packag,
                            cus_chartnum: data[i].cus_chartnum,
                            processing: data[i].processing,
                            datastatus: data[i].datastatus,
                            isfreeze: data[i].isfreeze,
                            custdraw_version: data[i].custdraw_version,
                            customsname: data[i].customsname,
                            base_price:data[i].base_price,
                            base_net_price:data[i].base_net_price,
                            
                        }]
                    }
                    
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: '',
                    name: that.editPlan
                };
                that.$http.urlpost('/Sal/Part/SalUpdate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }
    

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
    
</style>
